import {FETCH_INS_COMPANIES} from '../actions/types';

export const insCompaniesReducer = (state = [] , action) => {
    switch(action.type) {
        case FETCH_INS_COMPANIES:
            return [...action.payload] || [];

        default:
            return state;
    }
}